(ns dashboard.routes
  (:require [dashboard.browser-extension :as browser-extension]
            [dashboard.entity.organization.db :as organization-db]
            [dashboard.entity.questionnaire.db :as questionnaire.db]
            [dashboard.services.questionnaire-list :as questionnaire-list]
            [dashboard.views.analysis.analysis-bank.config :as analysis-bank-config]
            [dashboard.views.analysis.analysis-bank.view :as analysis-bank]
            [dashboard.views.answer-bank.view :as answer-bank]
            [dashboard.views.browser-extension.client-environments.config :as extension-client-environments-config]
            [dashboard.views.browser-extension.client-environments.view :as extension-client-environments-view]
            [dashboard.views.browser-extension.new-questionnaire.config :as extension-new-questionnaire-config]
            [dashboard.views.browser-extension.new-questionnaire.view :as extension-new-questionnaire-view]
            [dashboard.views.browser-extension.questionnaire-list.config :as extension-questionnaire-list-config]
            [dashboard.views.browser-extension.questionnaire-list.view :as extension-questionnaire-list-view]
            [dashboard.views.browser-extension.questionnaire.config :as extension-questionnaire-config]
            [dashboard.views.browser-extension.questionnaire.view :as extension-questionnaire-view]
            [dashboard.views.browser-extension.sandbox.view :as extension-sandbox]
            [dashboard.views.browser-extension.search.config :as extension-search-config]
            [dashboard.views.browser-extension.search.view :as extension-search-view]
            [dashboard.views.inference-job.detail.view :as inference-job-detail-view]
            [dashboard.views.login.view :as login-view]
            [dashboard.views.logout :as logout-view]
            [dashboard.views.organization.controller :as org.controller]
            [dashboard.views.organization.view :as organization]
            [dashboard.views.policy.view :as policies-view]
            [dashboard.views.prototypes.view :as prototypes]
            [dashboard.views.questionnaire.list.view :as questionnaires-view]
            [dashboard.views.questionnaire.question-list.config :as question-list-config]
            [dashboard.views.questionnaire.question-list.view :as question-list-view]
            [dashboard.views.statistics.view :as statistics-view]
            [dashboard.views.user-preferences.view :as user-preferences]
            [dashboard.views.workbook-workspace.view :as workbook-workspace-view]
            [malli.core :as m]
            [malli.transform :as mt]
            [re-frame.core :as rf]))

(defn home-content []
  [:div.section ""])

(defn home-hero []
  [:div.is-flex.is-justify-content-center
   [:img {:src "/img/repliance-icon.svg" :width "200px"
          :style {:justify-self "center"}}]])

(defn wrap-parameter-schema [routes]
  (mapv (fn [[path {:keys [controllers] parameters-schema :parameters :as route}]]
          (if controllers
            [path (update route :controllers
                          (fn [controllers]
                            (mapv (fn [{:keys [parameters] :as controller}]
                                    (if (and parameters parameters-schema)
                                      (let [{:keys [start stop]} controller]
                                        (cond-> controller
                                          start (update
                                                 :start
                                                 (fn [start]
                                                   (fn [parameters]
                                                     (start (m/decode parameters-schema parameters mt/string-transformer)))))
                                          stop (update
                                                :stop
                                                (fn [stop]
                                                  (fn [parameters]
                                                    (stop (m/decode parameters-schema parameters mt/string-transformer)))))))
                                      controller))
                                  controllers)))]
            [path route]))
        routes))


;; :name    route name - keyword
;; :content page view content component
;; :hero    page view hero component
;; :navbar  [:left :right] if unset do not render the item in navbar
(def app-routes
  (wrap-parameter-schema
    [["/"
      {:name    :route.view/home
       :content #'home-content
       :hero    #'home-hero
       :acl     #{"anonymous" "authenticated"}}]

     ["/documents"
      {:acl                #{"authenticated"}
       :name               :route.view/policies
       :content            #'policies-view/policies-page
       :controllers        policies-view/controllers
       :page               {:texts {:heading "Documents"}}
       :navbar             {:label    "Documents"
                            :position :left}
       :needs-some-feature #{:applied-analysis-creation}}]

     ["/questionnaires"
      {:acl         #{"authenticated"}
       :name        :route.view/questionnaires
       :content     #'questionnaires-view/view
       :controllers questionnaires-view/controllers
       :navbar      {:label    "Questionnaires"
                     :position :left}}]

     ["/answer-bank"
      {:acl #{"authenticated"}
       :name :route.view/answer-bank
       :layout {:is-fullwidth? true}
       :content #'answer-bank/list-view
       :controllers answer-bank/controllers
       :page {:texts {:heading "Answer bank"}}
       :navbar {:label "Answer bank"
                :position :left}
       :needs-some-feature #{:applied-analysis-creation}}]

     ["/analyses"
      {:acl #{"authenticated"}
       :name analysis-bank-config/view-id
       :content #'analysis-bank/view
       :controllers analysis-bank/controllers
       :layout {:is-fullwidth? true}
       :navbar {:label "Analyses"
                :position :left}
       :needs-some-feature #{:structured-analysis-creation :applied-analysis-creation}}]

     ["/questionnaires/:questionnaire-id/questions"
      {:acl #{"authenticated"}
       :layout {:is-fullwidth? true}
       :name question-list-config/view-id
       :content #'question-list-view/view
       :controllers question-list-view/controllers
       :page {:texts {:heading "Questions"}}}]

     ["/workbook-workspace"
      {:name        :route.view/workbook-workspace
       :content     #'workbook-workspace-view/workbook-workspace
       :acl         #{"authenticated"}
       :layout      {:is-fullwidth? true}
       ; :navbar      {:label    "Workbooks"
       ;              :position :left}
       :controllers workbook-workspace-view/controllers}]

     ;; ["/playground"
     ;;  {:acl #{"authenticated"}
     ;;   :name playground/view-id
     ;;   :content #'playground/view
     ;;   :navbar {:label "Playground"
     ;;            :position :left}
     ;;   :needs-some-feature #{:playground}}]

     ["/organization/member/:selected-person-id/:action"
      {:parameters [:map
                    [:path [:map
                            [:selected-person-id :int]
                            [:action :string]]]]
       :acl #{"authenticated"}
       :name organization-db/view-id-member-action
       :content #'organization/view
       :controllers org.controller/controllers
       :layout {:is-fullwidth? true}
       :needs-some-feature #{:applied-analysis-creation}}]

     ["/organization/member/:selected-person-id/"
      {:parameters [:map
                    [:path [:map
                            [:selected-person-id :int]]]]
       :acl #{"authenticated"}
       :name organization-db/view-id-member
       :content #'organization/view
       :controllers org.controller/controllers
       :layout {:is-fullwidth? true}
       :needs-some-feature #{:applied-analysis-creation}}]

     ["/organization"
      {:acl #{"authenticated"}
       :name organization-db/view-id-organization
       :content #'organization/view
       :controllers org.controller/controllers
       :layout {:is-fullwidth? true}
       :needs-some-feature #{:applied-analysis-creation}
       :navbar {:label "Organization"
                :position :left}}]

     ["/statistics"
      {:acl #{"authenticated"}
       :name statistics-view/view-id
       :content #'statistics-view/Statistics
       :controllers statistics-view/controllers
       :layout {:is-fullwidth? true}
       :navbar {:label "Statistics"
                :position :left}}]

     ["/prototypes"
      {:acl #{"authenticated"}
       :name prototypes/view-id-top
       :controllers analysis-bank/controllers
       :content #'prototypes/view
       :navbar {:label "Prototypes"
                :position :left}
       :needs-some-feature #{:prototypes}}]

     ["/prototypes/:mode"
      {:acl #{"authenticated"}
       :name prototypes/view-id-mode
       :controllers analysis-bank/controllers
       :content #'prototypes/view
       :needs-some-feature #{:prototypes}}]

     ["/inference-jobs/:questionnaire/:job-name"
      {:acl         #{"authenticated"}
       :name        :route.view/inference-job-detail
       :content     #'inference-job-detail-view/view
       :controllers inference-job-detail-view/controllers}]

     ["/user-preferences"
      {:acl #{"authenticated"}
       :name user-preferences/view-id
       :content #'user-preferences/View
       :navbar {:label [:span.icon.mr-1>i.fas.fa-user]
                :position :right}}]

     ["/login"
      {:acl         #{"anonymous"}
       :name        :route.view/login
       :page        {:texts {:heading "Login"}}
       :content     #'login-view/login-page
       :navbar      {:label    "Login"
                     :position :right}}]
     ["/logout"
      {:acl         #{"authenticated"}
       :name        :route.view/logout
       :page        {:texts {:heading "Logout"}}
       :content     #'logout-view/logout-page
       :navbar      {:label    "Logout"
                     :title    "Log out of this client environment"
                     :position :right}}]

     ["/browser-extension/search"
      {:acl #{"authenticated"}
       :name extension-search-config/view-id
       :layout {:content-only true}
       :content #'extension-search-view/search}]
     ["/browser-extension/client-environments"
      {:acl #{"anonymous" "authenticated"}
       :name extension-client-environments-config/view-id
       :content #'extension-client-environments-view/client-environments-page}]
     ["/browser-extension/questionnaires"
      {:acl #{"authenticated"}
       :name extension-questionnaire-list-config/view-id
       :controllers [{:start (fn [_]
                               (rf/dispatch [::questionnaire-list/get {:type "portal"}]))}]
       :content #'extension-questionnaire-list-view/questionnaires-page}]
     ["/browser-extension/questionnaires/:id"
      {:acl #{"authenticated"}
       :name extension-questionnaire-config/view-id
       :controllers [{:parameters {:path [:id]}
                      :start (fn [parameters]
                               (let [questionnaire-id (-> parameters :path :id uuid)]
                                 (rf/dispatch [::browser-extension/fetch-sections questionnaire-id])
                                 (questionnaire.db/get-questions questionnaire-id nil)
                                 (questionnaire.db/get-metadata questionnaire-id nil)))}]
       :content #'extension-questionnaire-view/questionnaire-page}]
     ["/browser-extension/new-questionnaire"
      {:acl #{"authenticated"}
       :name extension-new-questionnaire-config/view-id
       :content #'extension-new-questionnaire-view/new-questionnaire-page}]
     ["/browser-extension/sandbox"
      {:acl #{"authenticated"}
       :name :extension-sandbox
       :content #'extension-sandbox/sandbox-form}]]))
